<template>
  <div class="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 py-16 px-4">
    <div class="max-w-7xl mx-auto">
      <h1 class="text-4xl font-bold text-center mb-12 text-gray-900">Our Gallery</h1>
      <PhotoGallery :items="galleryItems" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import PhotoGallery from '@/components/photoGalleryComponent.vue'
import meetingImg from '@/assets/gallery/meeting.jpeg'
import trainingImg from '@/assets/gallery/training.jpeg'
import galleryImg1 from '@/assets/gallery/014d52f5-12b9-437b-bfba-bc29cb765330.webp'
import galleryImg2 from '@/assets/gallery/2b847207-6220-446a-a619-5adaef7e163d.webp'
import galleryImg3 from '@/assets/gallery/52619c93-664e-4b3c-ad57-02e5d10457cc.webp'
import firstRoadSafetyImg from '@/assets/gallery/first_road_safety.webp'

const galleryItems = ref([
  {
    image: meetingImg,
    title: 'Strategic Partnership for Safer Roads',
    previewText: 'Engaging with government stakeholders to implement HABITSAFE nationwide.',
    fullText: `Our CEO in a high-level meeting with the Director of Road Transport at Cameroon's Ministry of Transport. This pivotal discussion centered on the national implementation of HABITSAFE, our behavior-centered defensive driving program, aiming to forge a strategic partnership to significantly reduce road accidents and enhance public safety.`
  },
  {
    image: trainingImg,
    title: 'Championing Public Safety',
    previewText: 'Bringing the message of road safety directly to the community.',
    fullText: `The CEO of Ste HLC SARL delivers impactful road safety messages at the Bafoussam Urban Council trade fair. This event underscores our commitment to public sensitization and raising awareness, directly engaging with the community to foster a culture of safety and responsible driving habits.`
  },
  {
    image: firstRoadSafetyImg,
    title: 'Road Safety in Action',
    previewText: 'Documenting real-world road safety initiatives on the ground.',
    fullText: `A defining moment captured in the field  The CEO of on the front lines of road safety awareness. This image represents the core of what HABITSAFE stands for: moving beyond the classroom and into communities, putting behavior-centered safety principles into everyday practice where it matters most.`
  },
  {
    image: galleryImg1,
    title: 'Driving Change Together',
    previewText: 'Collaborative efforts shaping the future of road safety culture.',
    fullText: `The Manager of Ste Hoza Logistique Conseil SARL, speaking at the first Road Safety Forum in Cameroon organized by the Minister of Transport`
  },
  {
    image: galleryImg2,
    title: 'Building Safer Communities',
    previewText: 'Grassroots engagement to embed safety culture at every level.',
    fullText: `Safety is not a destination  it's a culture built one conversation at a time. HABITSAFE works at the grassroots level, engaging local communities to ensure that behavior-centered road safety becomes a shared value, embedded in daily life and upheld by every road user.`
  },
  {
    image: galleryImg3,
    title: 'Training the Next Generation',
    previewText: 'Equipping drivers with reflective skills that last a lifetime.',
    fullText: `The next generation of safe drivers is being shaped today. Through HABITSAFE's Question-Structured Techniques, participants develop lasting habits  not just passing knowledge. This session reflects our commitment to transforming how drivers think, respond, and take responsibility behind the wheel.`
  }
])
</script>